import type { RouteObject } from 'react-router-dom'

import { coreRoutes } from './core.routes'
import { strategyRoutes } from './strategy.routes'
import { maturityRoutes } from './maturity.routes'
import { governanceProRoutes } from './governance-pro.routes'
import { securityProRoutes } from './security-pro.routes'
import { riskProRoutes } from './risk-pro.routes'
import { auditProRoutes } from './audit-pro.routes'
import { aiIaProRoutes } from './ai-ia-pro.routes'
import { dataProRoutes } from './data-pro.routes'
import { complianceProRoutes } from './compliance-pro.routes'
import { changeProRoutes } from './change-pro.routes'
import { vendorProRoutes } from './vendor-pro.routes'
import { dashboardProRoutes } from './dashboard-pro.routes'
import { ethicsProRoutes } from './ethics-pro.routes'
import { maturityProRoutes } from './maturity-pro.routes'
import { strategyProRoutes } from './strategy-pro.routes'
import { workspaceProRoutes } from './workspace-pro.routes'
import { businessModelProRoutes } from './business-model-pro.routes'
import { taxProRoutes } from './tax-pro.routes'
import { legalRoutes } from './legal.routes'
import { privacyRoutes } from './privacy.routes'
import { frameworkEngineRoutes } from './framework-engine.routes'
import { enterpriseArchitectureRoutes } from './enterprise-architecture.routes'
import { pdcaRoutes } from './pdca.routes'
import { caseMgmtRoutes } from './case-mgmt.routes'
import { transformationProRoutes } from './transformation-pro.routes'
import { certificationProcessRoutes } from './certification-process.routes'
import { orgContextRoutes } from './org-context.routes'
import { esgRoutes } from './esg.routes'
import { regChangeRoutes } from './reg-change.routes'
import { regEngagementRoutes } from './reg-engagement.routes'
import { policyMgmtRoutes } from './policy-mgmt.routes'
import { aiIntelligenceRoutes } from './ai-intelligence.routes'
import { iso42001Routes } from './iso42001.routes'
import { frameworksRoutes } from './frameworks.routes'
import { automationRoutes } from './automation.routes'
import { analyticsRoutes } from './analytics.routes'
import { jurisdictionRoutes } from './jurisdiction.routes'
import { riskIntelligenceRoutes } from './risk-intelligence.routes'
import { connectedGrcRoutes } from './connected-grc.routes'
import { importHubRoutes } from './import-hub.routes'
import { workflowBuilderRoutes } from './workflow-builder.routes'
import { aiHubRoutes } from './ai-hub.routes'
import { bookingRoutes } from './booking.routes'
import { forumRoutes } from './forum.routes'
import { feedRoutes } from './feed.routes'
import { evaluationRoutes } from './evaluation.routes'

// All protected routes (rendered inside MainLayout with ProtectedRoute wrapper)
export const protectedRoutes: RouteObject[] = [
  ...frameworkEngineRoutes,
  ...strategyRoutes,
  ...maturityRoutes,
  ...governanceProRoutes,
  ...securityProRoutes,
  ...riskProRoutes,
  ...auditProRoutes,
  ...aiIaProRoutes,
  ...dataProRoutes,
  ...complianceProRoutes,
  ...changeProRoutes,
  ...vendorProRoutes,
  ...dashboardProRoutes,
  ...ethicsProRoutes,
  ...maturityProRoutes,
  ...strategyProRoutes,
  ...workspaceProRoutes,
  ...businessModelProRoutes,
  ...taxProRoutes,
  ...legalRoutes,
  ...privacyRoutes,
  ...enterpriseArchitectureRoutes,
  ...pdcaRoutes,
  ...caseMgmtRoutes,
  ...transformationProRoutes,
  ...certificationProcessRoutes,
  ...orgContextRoutes,
  ...esgRoutes,
  ...regChangeRoutes,
  ...regEngagementRoutes,
  ...policyMgmtRoutes,
  ...aiIntelligenceRoutes,
  ...iso42001Routes,
  ...frameworksRoutes,
  ...automationRoutes,
  ...analyticsRoutes,
  ...jurisdictionRoutes,
  ...riskIntelligenceRoutes,
  ...connectedGrcRoutes,
  ...importHubRoutes,
  ...workflowBuilderRoutes,
  ...aiHubRoutes,
  ...forumRoutes,
  ...bookingRoutes,
  ...feedRoutes,
  ...evaluationRoutes,
  // coreRoutes last because it contains the catch-all '*' route
  ...coreRoutes,
]
